import { inject } from '@angular/core';
import { CanActivateFn, RedirectCommand, Router } from '@angular/router';
import { AuthService } from '../services/authentication.service';
import { GlobalService } from 'src/app/shared/ui/services/global.service';

export const LoginEntryGuard: CanActivateFn = async (route, state): Promise<boolean | RedirectCommand> => {
    const authService = inject(AuthService);
    const globalService = inject(GlobalService);
    const router = inject(Router);

    // Helper to determine redirect target, prioritizing the 'redirect' parameter
    const getRedirectTarget = (): string => {
        const redirectUrl = route.queryParams['redirect'];
        return redirectUrl ? redirectUrl : globalService.getHomeUrlBasedOnRoles();
    };

    // User is already authenticated, redirect according to their roles
    if (authService.isAuthenticated()) {
        return new RedirectCommand(router.parseUrl(getRedirectTarget()));
    } else {
        // loadSessionFromToken try to restore session if token exists and is valid
        const authenticated = await authService.loadSessionFromToken();
        // If token is valid and user session is created
        if (authenticated) {
            return new RedirectCommand(router.parseUrl(getRedirectTarget()));
        }
    }

    // No session, not valid token → continue to login
    return true;
};
